/**
 * Internal tools for the internal tool. How meta.
 */
import { RouteGroup } from '@/types/routing-types'


export default [
    {
        name: 'internal-tools-audit',
        path: '/internal-tools-audit',
        component: () => import('@/pages/tech-team/InternalToolsAudit.vue'),
        meta: {
            title: 'Internal Tools Audit',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.TECH_TEAM
        }
    },
    {
        name: 'internal-tools-leaderboard',
        path: '/internal-tools-leaderboard',
        component: () => import('@/pages/tech-team/InternalToolsLeaderboard.vue'),
        meta: {
            title: 'Internal Tools Leaderboard',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.TECH_TEAM
        }
    }
]
